import { createApp } from 'vue'
import { createPinia } from 'pinia'
import './style.css'
import './components/toolbar-menus.css'
import { initPlatformBridge } from './services/platformBridge'
import { useFontsStore } from './stores/fonts'
import { startUpdateManager } from './services/updateManager'
import AppGate from './AppGate.vue'
import { startToolColors } from './services/toolColors'
import { IS_MOBILE_APP } from './utils/appVariant'

initPlatformBridge().then(() => {
  const app = createApp(AppGate, { mobile: IS_MOBILE_APP })
  const pinia = createPinia()
  app.use(pinia)
  void useFontsStore(pinia).initializeCatalogFonts().catch((error) => {
    console.warn('[FontCatalog] Boot rehydration failed:', error)
  })
  startToolColors(pinia)
  app.mount('#app')
  startUpdateManager()
  if (__IS_WEB__) void import('./services/webOfflineRuntime').then(runtime => runtime.startWebOfflineRuntime())
})
